import React from 'react';
import { MenuType } from '../../redux/userManagement/userManagementTypes';
import { Checkbox } from '../commons';
import NestedListItem from './NestedMenuList';
import NestedMenuList from './NestedMenuList';
import NormalMenuList from './NormalMenuList';

type AppProps = {
  sideMenus: [] | MenuType[];
  selectedMenus: [] | number[];
  handleSelectMenus: (menuId: number) => void;
}

const SideMenus = ({
  sideMenus,
  selectedMenus,
  handleSelectMenus
}: AppProps) => {

  const renderNormalSideMenuList = () => {
    let finalList = sideMenus?.length > 0 && sideMenus?.map((sideMenu: MenuType) => {
      if (sideMenu?.sub_menu?.length === 0) {
        return (
          <NormalMenuList
            menuDetails={sideMenu}
            selectedMenus={selectedMenus}
            handleSelectMenu={handleSelectMenus}
          />
        )
      }
    });

    return finalList;
  };

  const renderNestedSideMenuList = () => {
    let finalList = sideMenus?.length > 0 && sideMenus?.map((sideMenu: MenuType) => {
      if (sideMenu?.sub_menu?.length > 0) {
        return (
          <>
            <h5 className='mt-2 mb-1'>{sideMenu?.menu_name}</h5>
            <NestedListItem
              menuDetails={sideMenu}
              selectedMenus={selectedMenus}
              handleSelectMenu={handleSelectMenus}
              indentation={0}
            />
            <hr />
          </>
        )
      }
    });

    return finalList;
  }

  return (
    <>
      <div className="row">
        {renderNormalSideMenuList()}
      </div>
      {renderNestedSideMenuList()}
    </>
  )
};

export default SideMenus;